// This components is a smaller version of the project table, it is used to display a list of projects in a compact way

import { MiniProjectList } from "@/components/Projects/Table/ProjectList";
import { SectionDiv } from "./Components/SectionDiv";

export function MiniProjectListContainer() {
    return (
        <SectionDiv className="overflow-y-auto">
            <h3 className="">Project List:</h3>
            <MiniProjectList />
        </SectionDiv>
    )
}